var map = {
	"./1d.js": 606,
	"./classic.js": 231,
	"./continous.js": 203,
	"./finiteTemperature.js": 928,
	"./halfLife.js": 968,
	"./quartiles.js": 685,
	"./testMode.js": 892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 390;